// generated by the plop

export interface ReceiptStateModel {
  isConnected: boolean;
}

export const RECEIPT_STATE_DEFAULT: ReceiptStateModel = {
  isConnected: false
};
